module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-supply-chain-2017-supply-chain-cell1.d4b8e50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-supply-chain-2017-supply-chain-cell1.jpg
// module id = Vfcu
// module chunks = 0